import ClapperIcon from '@/images/ClapperIcon.png';
import {
    ITranslation,
    ITranslationGroup,
    LibraryItem,
    LibraryItemStatus,
    LibraryItemType,
    SUPPORTED_LANGUAGES,
    TranslationGroupStatus,
} from '@d-id/types';
import styled from '@emotion/styled';
import { DEFAULT_GROUP_TRANSLATION_ERROR, ERROR_TEXT_BY_KIND, ORIGINAL } from './constants';
import { ERROR_KINDS } from './hooks/useCreateTranslation';

const StyledIcon = styled.img`
    width: 16px;
`;

export const getErrorTextByKind = (errorKind?: string): string => {
    const errorKindsAsStringArray: string[] = Object.values(ERROR_KINDS) as string[];
    if (!errorKind || !errorKindsAsStringArray.includes(errorKind)) {
        return DEFAULT_GROUP_TRANSLATION_ERROR;
    }

    const validErrorKind = errorKind as ERROR_KINDS;

    return ERROR_TEXT_BY_KIND[validErrorKind];
};

export const getBadgeIconFromLocale = (locale: string | null): JSX.Element | null => {
    if (!locale) {
        return null;
    }

    if (locale === ORIGINAL) {
        return <StyledIcon loading="lazy" src={ClapperIcon} />;
    }

    const code = locale.split('-')?.[1]?.toLowerCase();
    return code ? <StyledIcon loading="lazy" src={`https://flagcdn.com/192x144/${code}.png`} alt={code} /> : null;
};

export function getBadgeIcon(language: string | null): JSX.Element | null {
    if (!language) {
        return null;
    }
    const locale = SUPPORTED_LANGUAGES[language.toLowerCase()];
    if (!locale) {
        return null;
    }

    return getBadgeIconFromLocale(locale);
}

export const transformToLibraryItem = (translation: ITranslation): LibraryItem => {
    return {
        id: translation.id,
        name: translation.name,
        type: LibraryItemType.TRANSLATION,
        created_at: translation.created_at,
        modified_at: translation.modified_at,
        video_url: translation.result_url,
        status: translation.status as unknown as LibraryItemStatus,
        thumbnail_url: translation.thumbnail_url || '',
        duration: translation.duration,
        subtitles_url: translation.subtitles_url,
    };
};

export const isGroupDraftEditable = (group?: ITranslationGroup): boolean => {
    if ([TranslationGroupStatus.Error, TranslationGroupStatus.Done].includes(group?.status!) || !group?.translations?.length) {
        return false;
    }
    return group.translations.every(
        translation =>
            translation.proofreading &&
            !translation.generated_at &&
            translation.transcriptions?.some(transcription => transcription.selected)
    );
};

export const isGroupReadonly = (group: ITranslationGroup): boolean => {
    if (!group.translations?.length) {
        return true;
    }
    return group.translations.some(translation => !translation.proofreading || !!translation.generated_at);
};
